module.exports = __webpack_public_path__ + "img/car.27836d4.svg";